import { useState, useEffect } from 'react';
import type { RefObject } from 'react';

const useIntersectionVisibility = (
  ref: RefObject<HTMLElement>,
  options: IntersectionObserverInit
) => {
  const [isFullyVisible, setIsFullyVisible] = useState(true);

  useEffect(() => {
    if (!ref.current) return () => {};

    const observer = new IntersectionObserver(
      ([e]) => setIsFullyVisible(e.intersectionRatio === 1),
      {
        threshold: [1],
        ...options
      }
    );

    observer.observe(ref.current);

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref.current]);

  return { isFullyVisible };
};

export default useIntersectionVisibility;
